import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  SUBSCRIPTION_BUTTON,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchSubscriptionButton = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SUBSCRIPTION_BUTTON}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SUBSCRIPTION_BUTTON}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.SUBSCRIPTION_BUTTON}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.SUBSCRIPTION_BUTTON}${query}${sorting}`);
};

const postSubscriptionButton = async payload => axiosAuthInstance.post(API_END_POINTS.SUBSCRIPTION_BUTTON, payload);

export function* getSubscriptionButton(action) {
  try {
    const { data: { entity } } = yield call(fetchSubscriptionButton, action.payload);
    yield put({ type: SUBSCRIPTION_BUTTON.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: SUBSCRIPTION_BUTTON.FAILED, payload: e.response.data });
  }
}

export function* addSubscriptionButton(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(postSubscriptionButton, action.payload);
    const { data: { entity } } = yield call(fetchSubscriptionButton, action.payload);
    yield put({ type: SUBSCRIPTION_BUTTON.SUCCESS, payload: entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.SUBSCRIPTION_BUTTON.ADD_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}
